import React, { useState, useEffect, useRef } from "react";
import { useForm, ValidationError } from '@formspree/react';
import styles from "./Contact.module.css";
import { FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import { FiInstagram, FiLinkedin } from "react-icons/fi";

const Contact = () => {
  const [state, handleSubmit] = useForm("xblypjlp");

  const [isVisible, setIsVisible] = useState({
    heading: false,
    contactInfo: false,
    contactForm: false
  });
  
  const sectionRef = useRef(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(prev => ({ ...prev, heading: true })), 100);
          setTimeout(() => setIsVisible(prev => ({ ...prev, contactInfo: true })), 300);
          setTimeout(() => setIsVisible(prev => ({ ...prev, contactForm: true })), 500);
          
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    
    const currentRef = sectionRef.current;
    
    if (currentRef) {
      observer.observe(currentRef);
    }
    
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section className={styles.contact} id="contact" ref={sectionRef}>
      <div className={styles.backgroundDecoration}></div>
      <div className={styles.container}>
        <div
          className={`${styles.heading} ${isVisible.heading ? styles.visible : ""}`}
        >
          <span className={styles.sectionLabel}>Get in Touch</span>
          <h2 className={styles.title}>Contact Us</h2>
          <div className={styles.underline}></div>
          <p className={styles.subtitle}>Have a question or want to work with us? We'd love to hear from you.</p>
        </div>

        <div className={styles.contactContent}>
          <div
            className={`${styles.contactInfo} ${isVisible.contactInfo ? styles.visible : ""}`}
          >
            <div className={styles.infoCards}>
              <div className={styles.infoCard}>
                <div className={styles.infoIcon}>
                  <FaPhone />
                </div>
                <h3 className={styles.infoTitle}>Phone</h3>
                <p className={styles.infoText}>
                  <a href="tel:+6045622408">(604) 562-2408</a>
                </p>
              </div>
              
              <div className={styles.infoCard}>
                <div className={styles.infoIcon}>
                  <FaMapMarkerAlt />
                </div>
                <h3 className={styles.infoTitle}>Office</h3>
                <p className={styles.infoText}>
    
                  Vancouver, BC, Canada
                </p>
              </div>
              
              <div className={styles.socialContainer}>
                <h3 className={styles.socialTitle}>Connect With Us</h3>
                <div className={styles.socialLinks}>
                
                  <a href="https://www.instagram.com/" className={styles.socialIcon} aria-label="Instagram">
                    <FiInstagram />
                  </a>
                  <a href="https://www.linkedin.com/company/canacon/" className={styles.socialIcon} aria-label="LinkedIn">
                    <FiLinkedin />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`${styles.contactForm} ${isVisible.contactForm ? styles.visible : ""}`}
          >
            <div className={styles.formCard}>
              <h3 className={styles.formTitle}>Send us a message</h3>
              
              {state.succeeded ? (
                <div className={styles.successMessage}>
                  <div className={styles.successIcon}>✓</div>
                  <h3>Thanks for your message!</h3>
                  <p>We appreciate you contacting us and will respond shortly.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className={styles.formContent}>
                  <div className={styles.formGrid}>
                    <div className={styles.formGroup}>
                      <label htmlFor="name">Your Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="John Doe"
                        required
                      />
                      <ValidationError 
                        prefix="Name" 
                        field="name"
                        errors={state.errors}
                      />
                    </div>
                    
                    <div className={styles.formGroup}>
                      <label htmlFor="email">Your Email *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="john@example.com"
                        required
                      />
                      <ValidationError 
                        prefix="Email" 
                        field="email"
                        errors={state.errors}
                      />
                    </div>
                  </div>
                  
                  <div className={styles.formGroup}>
                    <label htmlFor="subject">Subject</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      placeholder="How can we help you?"
                    />
                    <ValidationError 
                      prefix="Subject" 
                      field="subject"
                      errors={state.errors}
                    />
                  </div>
                  
                  <div className={styles.formGroup}>
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      placeholder="Your message here..."
                      required
                    ></textarea>
                    <ValidationError 
                      prefix="Message" 
                      field="message"
                      errors={state.errors}
                    />
                  </div>
                  
                  <button type="submit" className={styles.submitButton} disabled={state.submitting}>
                    Send Message
                    <span className={styles.buttonIcon}>→</span>
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 